export default __webpack_public_path__ + "static/media/arrow-right-slider.3e4be123.svg";